import { render, staticRenderFns } from "./coupon.vue?vue&type=template&id=79357764&scoped=true"
import script from "./coupon.vue?vue&type=script&lang=ts"
export * from "./coupon.vue?vue&type=script&lang=ts"
import style0 from "./coupon.vue?vue&type=style&index=0&id=79357764&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79357764",
  null
  
)

export default component.exports